"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailPage = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../Theme");
var Wrapper = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: grid;\n    padding: 1.5em;\n    grid-template-rows: calc(30px + 0.75em) 50px auto;\n    grid-gap: 0.75em;\n"], ["\n    ", ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: grid;\n    padding: 1.5em;\n    grid-template-rows: calc(30px + 0.75em) 50px auto;\n    grid-gap: 0.75em;\n"])), Theme_1.Color.Grey.Lightest);
var DetailPage = /** @class */ (function (_super) {
    __extends(DetailPage, _super);
    function DetailPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildStyle = function () {
            var style = {};
            switch (_this.props.Layout) {
                case "ExcludeAside":
                    style = __assign(__assign({}, style), { gridTemplateAreas: "'header' 'tabs' 'content'", gridTemplateColumns: "auto" });
                    break;
                default:
                    style = __assign(__assign({}, style), { gridTemplateAreas: "'header header' 'aside tabs' 'aside content'", gridTemplateColumns: "325px auto" });
            }
            return style;
        };
        return _this;
    }
    DetailPage.prototype.render = function () {
        return (React.createElement(Wrapper, { style: this.buildStyle() }, this.props.children));
    };
    return DetailPage;
}(React.Component));
exports.DetailPage = DetailPage;
var templateObject_1;
